import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { materialModules } from '../../angular-material.module';
import { TippyDirective } from '@ngneat/helipopper';
import { AiConversationShellComponent } from './conversation/ai-conversation-shell.component';
import { AiTranscriptOutletComponent, AI_RENDERERS } from './transcript/ai-transcript-outlet.component';
import { TextRendererComponent } from './renderers/text-renderer/text-renderer.component';
import { CopySuggestionsRendererComponent } from './renderers/copy-suggestions-renderer/copy-suggestions-renderer.component';
import { PhotoGridRendererComponent } from './renderers/photo-grid-renderer/photo-grid-renderer.component';
import { AI_ADAPTER } from './adapter/adapter';
import { MockAiAdapterService } from './adapter/mock-ai-adapter.service';
import { AiGatewayService } from './adapter/ai-gateway.service';
import { SharedPipeModule } from '../pipes/shared-pipe.module';

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, TippyDirective, ...materialModules, SharedPipeModule],
  declarations: [
    AiConversationShellComponent,
    AiTranscriptOutletComponent,
    TextRendererComponent,
    CopySuggestionsRendererComponent,
    PhotoGridRendererComponent,
  ],
  providers: [
    { provide: AI_RENDERERS, multi: true, useValue: { type: 'text', component: TextRendererComponent } },
    { provide: AI_RENDERERS, multi: true, useValue: { type: 'copy-group', component: CopySuggestionsRendererComponent } },
    { provide: AI_RENDERERS, multi: true, useValue: { type: 'photo-grid', component: PhotoGridRendererComponent } },
    // Switch to AiGatewayService for real backend integration
    { provide: AI_ADAPTER, useClass: AiGatewayService }
  ],
  exports: [AiConversationShellComponent, AiTranscriptOutletComponent]
})
export class AiModule {}
